import type { RequestRow } from "./requestLogGridTypes";

import { createGridSelectionHelpers } from "@/components/ui/ag-grid-table";

const parseRowId = (raw: RequestRow["id"] | undefined): number | null => {
  const numeric = typeof raw === "number" ? raw : Number(raw);
  return Number.isFinite(numeric) ? numeric : null;
};

export const getRequestRowId = (data: RequestRow | undefined): number | null =>
  parseRowId(data?.id);

const helpers = createGridSelectionHelpers<number, RequestRow>(getRequestRowId);

export const { collectLoadedRowIds, collectCurrentPageRowIds, collectLoadedSelectedRowIds } =
  helpers;
